export default __webpack_public_path__ + "static/media/frog.70a59359.jpg";